import { create } from 'zustand';

import { resolvePreset, type DateRange } from '@/components/shared/date-range-filter';

const fallbackTimezone = (): string => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'Africa/Accra';
  } catch {
    return 'Africa/Accra';
  }
};

const defaultRange = (timezone: string): DateRange => ({
  preset: 'allTime',
  ...resolvePreset('allTime', timezone),
});

interface ContentPeriodState {
  dateRange: DateRange;
  setDateRange: (range: DateRange) => void;
}

/** Shared Content period — changing it on one tab updates every tab. */
export const useContentPeriodStore = create<ContentPeriodState>((set) => ({
  dateRange: defaultRange(fallbackTimezone()),
  setDateRange: (dateRange) => set({ dateRange }),
}));
